import React, { ReactElement, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Dispatch } from 'redux';
import { NavigateFunction } from 'react-router-dom';

import { RootState } from '../../../types/state/root.types';
import { RegistrationState } from '../../../types/state/registration.types';
import { Programme } from '../../../types/entity.types';

import { requestFindActiveProgrammes } from '../../../api/external-registration/external-registration.actions';

import Registration from '../../../components/screens/auth/registration/Registration';

const RegistrationContainer = (): ReactElement => {
  const { programmes } = useSelector((state: RootState): RegistrationState => state.registration);

  const [searchParams] = useSearchParams();

  const dispatch: Dispatch = useDispatch();

  const navigate: NavigateFunction = useNavigate();

  useEffect((): void => {
    dispatch(requestFindActiveProgrammes());
  }, [dispatch]);

  const availableProgrammes: Programme[] = useMemo((): Programme[] => {
    if (!programmes) return [];

    return programmes.filter((programme: Programme): boolean => !!programme.hasRegistrationRequirements);
  }, [programmes]);

  const navigateToProgramme = (externalReference: string): void => {
    const theme: string | null = searchParams.get('theme');
    if (theme) {
      navigate(`${externalReference}?theme=${theme}`);
    } else {
      navigate(externalReference);
    }
  };

  return <Registration programmes={availableProgrammes} navigateToProgramme={navigateToProgramme} />;
};

export default RegistrationContainer;
